import { Container } from '@mui/material'
import Box from '@mui/material/Box'
import { Logo } from '@/shared/ui/Logo'
import { useAppStore } from '@/shared/store'
import { MenuButtons } from './components/MenuButtons'
import { ProfileMenu, SearchBar } from '@/features'
import React from 'react'

const TopMenu = () => {
    const { isUserLoggedIn } = useAppStore()

    const containerStyle = {
        background: 'black',
        zIndex: 2,
        position: { xs: 'static', sm: 'sticky' },
        top: 0,
    }
    const menuButtonsContainerStyle = {
        width: '100%',
        maxWidth: isUserLoggedIn ? '600px' : '100%',
        display: 'flex',
        alignItems: 'center',
        mr: { xs: '8px', md: 0 },
        justifyContent: 'center',
    }
    const contentWrapperStyle = {
        padding: '18px 0',
        display: 'flex',
        justifyContent: isUserLoggedIn ? 'space-between' : 'left',
        alignItems: 'center',
        overflow: { xs: 'auto', md: 'hidden' },
    }

    return (
        <Box sx={containerStyle}>
            <Container maxWidth="xl">
                <Box sx={contentWrapperStyle}>
                    <Logo />
                    <Box sx={menuButtonsContainerStyle}>
                        <MenuButtons />
                    </Box>
                    <Box display="flex" alignItems="center" maxWidth="596px">
                        <SearchBar />
                        <ProfileMenu />
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export { TopMenu }
